const KeenSlider = window.KeenSlider

const { setInitialised, useA11y, useArrows } = window.BAO.Carousel.plugins

class BannerCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.5,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 1201px)': {
            slides: {
              perView: 3.8,
              spacing: 10,
            },
          },
        },
      },
      [
        setInitialised(),
        useA11y(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('banner-carousel')) {
  customElements.define('banner-carousel', BannerCarousel)
}
